import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { recordThrownError } from './diagnostics';

export const queryClient = new QueryClient({
  // ERRORS-1: every failed query/mutation leaves its error CODE + request id in the
  // diagnostics ring buffer, so a later bug report can say what led up to it. Codes only —
  // see lib/diagnostics.ts. Observational: it changes no retry or error behavior.
  queryCache: new QueryCache({ onError: recordThrownError }),
  mutationCache: new MutationCache({ onError: recordThrownError }),
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
